function reducer(state, action) {
    switch (action.type) {
        case 'USER_IS_LOADING':
            return {
                ...state,
                isUserLoading: true,
            };

        case 'USER_NOT_LOADING':
            return {
                ...state,
                isUserLoading: false,
            };

        case 'FETCH_USER_FAIL':
            return {
                ...state,
                isUserLoading: false,
                userState: 'error',
                ...action.payload,
            };

        case 'USER_FETCHED':
            return {
                ...state,
                // fetchedProfile: true,
                userState:
                    action?.payload?.user?.permissions
                        ?.canAccessWithoutPaymentInfo ||
                    action?.payload?.subscription_info?.subscription_status ===
                        'active'
                        ? 'isUser'
                        : 'suspended',
                isUserLoading: false,
                ...action.payload,
                isNewRegistration:
                    (state.isNewRegistration || action.payload?.isNewRegistration) ??
                    false,
            };

        case 'USER_EMAIL_NOT_VERIFIED':
            return {
                ...state,
                userState: 'emailNotVerified',
                isUserLoading: false,
                user: null,
            };

        case 'USER_NOT_ON_TEST_LIST':
            return {
                ...state,
                userState: 'notOnTestList',
                isUserLoading: false,
                user: null,
            };
        case 'UPDATE_SUBSCRIPTION':
            return {
                ...state,
                subscription_info: {
                    ...state.subscription_info,
                    ...action.payload,
                },
            };
        case 'UPDATE_USER':
            return {
                ...state,
                user: {...state.user, ...action.user},
            };
        case 'UPDATE_PROFILE':
            return {
                ...state,
                profile: {...state.profile, ...action.profile},
            };
        case 'UPDATE_PAYMENT':
            return {
                ...state,
                payment: {...state.payment, ...action.payment},
            };
        case 'UPDATE_BILLING_INFO':
            return {
                ...state,
                billingInfo: {...state.billingInfo, ...action.billingInfo},
            };
        case 'REGISTER':
            return {
                ...state,
                isNewRegistration: false,
            };
        case 'LOGOUT':
            return {
                ...state,
                userState: 'loggedOut',
                authState: 'unAuthenticated',
                isUserLoading: false,
                user: null,
            };
        case 'TOGGLE_PRO':
            return {
                ...state,
                subscription_info: {
                    ...state.subscription_info,
                    subscription_type:
                        state.subscription_info.subscription_type === 'pro'
                            ? 'free'
                            : 'pro',
                },
            };

        default:
            return state;
    }
}

export default reducer;
